import "core-js/stable";
import Vue from "vue";
import App from "./App.vue";
import Gtag from "vue-gtag";
import i18n from "@/i18n";
import "@/assets/tailwind.css";
import localeUtilities from "@/mixins/localeUtilities.js";

Vue.config.productionTip = false;

if (process.env.NODE_ENV === "production") {
  Vue.use(Gtag, {
    config: { id: "GTM-MHCX69W" },
  });
}

Vue.mixin(localeUtilities);

new Vue({
  i18n,
  render: h => h(App),
}).$mount("#app");
